import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SubBanner from '../components/SubBanner';
import SalesforceExplainerListing from '../components/SalesforceExplainerListing';
import ContactForm from '../components/ContactForm';

const SalesforceExplainerListingPageTemplate = ({
  data: {
    datoCmsSalesforceExplainerListing,
    allDatoCmsSalesforceExplainer: { nodes },
    allSalesforceExplainer: { nodes: initialSearchItems },
    allDatoCmsSalesforceExplainerBusinessFunction: { nodes: businessFunctions },
    allDatoCmsSalesforceExplainerProduct: { nodes: products },
    allDatoCmsSalesforceExplainerPopularFeature: { nodes: popularFeatures },
  },
  location,
  pageContext: { totalPageCount, currentPageCount },
}) => {
  const {
    seoMetaTags,
    title,
    bannerText,
    bannerImage,
    contentHeading,
    contentText,
  } = datoCmsSalesforceExplainerListing;

  const [searchResults, setSearchResults] = useState();
  const [searchItems, setSearchItems] = useState([]);

  useEffect(() => {
    const updatedItems = initialSearchItems.map(item => ({
      ...item,
      products: item.products.length === 0 ? products : item.products,
    }));
    setSearchItems(updatedItems);
  }, [initialSearchItems, products]);

  return (
    <Layout seo={seoMetaTags} page={datoCmsSalesforceExplainerListing}>
      <main>
        <SubBanner heading={title} text={bannerText} image={bannerImage} />
        <SalesforceExplainerListing
          heading={contentHeading}
          text={contentText}
          items={nodes}
          currentPage={datoCmsSalesforceExplainerListing}
          searchItems={searchItems}
          searchResults={searchResults}
          setSearchResults={setSearchResults}
          location={location}
          totalPageCount={totalPageCount}
          listingPage={datoCmsSalesforceExplainerListing}
          currentPageCount={currentPageCount}
          businessFunctions={businessFunctions}
          products={products}
          popularFeatures={popularFeatures}
        />
      </main>
      <ContactForm />
    </Layout>
  );
};

export const SalesforceExplainerListingPageTemplateQuery = graphql`
  query SalesforceExplainerListingPageTemplateQuery($skip: Int!) {
    datoCmsSalesforceExplainerListing {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      bannerText {
        value
      }
      bannerImage {
        url
        alt
      }
      contentHeading
      contentText {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      ...LinkFragment
    }
    allDatoCmsSalesforceExplainerBusinessFunction(sort: { name: ASC }) {
      nodes {
        name
      }
    }
    allDatoCmsSalesforceExplainerProduct(sort: { name: ASC }) {
      nodes {
        name
      }
    }
    allDatoCmsSalesforceExplainerPopularFeature(sort: { name: ASC }) {
      nodes {
        name
      }
    }
    allDatoCmsSalesforceExplainer(
      sort: { position: ASC }
      skip: $skip
      limit: 10
    ) {
      nodes {
        ...SalesforceExplainerCardFragment
      }
    }
    allSalesforceExplainer: allDatoCmsSalesforceExplainer(
      sort: { position: ASC }
    ) {
      nodes {
        ...SalesforceExplainerCardFragment
      }
    }
  }
`;

export default SalesforceExplainerListingPageTemplate;
